export default __webpack_public_path__ + "f4fe7380d6bba564e938f7b7dbb274d5.svg";